//* 팀장유저 수정 및 생성을 위한 form interface

export enum BugoBrandAgencyWorkerFormInputsEnum {
  UserName = 'username',
  Password = 'password',
  Name = 'name',
  NickName = 'nickName',
  PhoneNumber = 'phoneNumber',
  TeamType = 'teamType',
  TeamName = 'teamName',
  Region = 'region',
}

export interface BugoBrandAgencyWorkerFormInputs {
  [BugoBrandAgencyWorkerFormInputsEnum.UserName]?: string;
  [BugoBrandAgencyWorkerFormInputsEnum.Password]?: string;
  [BugoBrandAgencyWorkerFormInputsEnum.Name]: string;
  //* 정산 표기용 닉네임 (동명이인 구분, 선택)
  [BugoBrandAgencyWorkerFormInputsEnum.NickName]?: string;
  [BugoBrandAgencyWorkerFormInputsEnum.PhoneNumber]: string;
  [BugoBrandAgencyWorkerFormInputsEnum.TeamType]: string;
  [BugoBrandAgencyWorkerFormInputsEnum.TeamName]: string;
  [BugoBrandAgencyWorkerFormInputsEnum.Region]: string;
}
